//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'ABCD2SCORE',
  data () {
    return {
      form: {
        data1: '0',
        data2: '0',
        data3: '',
        data4: '',
        data5: ''
      },
      dataList3: [
        {value: '2', name: '单侧无力或伴言语障碍'},
        {value: '1', name: '仅有言语障碍不伴无力'},
        {value: '0', name: '无症状'}
      ],
      dataList4: [
        {name: '10~59min', value: '1'},
        {name: '>60min', value: '2'}
      ],
      dataList5: [
        {value: '1', name: '有'},
        {value: '0', name: '无'}
      ],
      descTxt: ''
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad'])
  },
  computed: {
    /** 计算公式结果 */
    score () {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      let result = 0
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            form[key] = Number(form[key])
            result += form[key]
          }
        }
      }
      if (!flag) {
        return ''
      }
      if (result >= 3) {
        self.descTxt = '高危患者'
      }
      return String(result)
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Card/ABCD2SCORE.vue